import { FiltersBar, SearchInput, useFilterUpdate } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useShipmentTemplateListFilter } from './useShipmentTemplateListFilter';

export function Filters() {
  const { search, setSearch } = useShipmentTemplateListFilter();
  const { t } = useTranslation();

  useFilterUpdate('search', search);

  return (
    <FiltersBar.Row>
      <SearchInput
        placeholder={t('shipmentTemplates.list.searchPlaceholder')}
        onChange={v => setSearch(v)}
        defaultValue={search}
      />
    </FiltersBar.Row>
  );
}
